import { FC, PropsWithChildren, Suspense } from 'react'

import LoadingOverlay from '@/components/componentLibrary/LoadingOverlay'
import { useSuspenseLayers } from '@/modules/layers/queries'

const RequireLayers: FC<PropsWithChildren> = ({ children }) => {
  useSuspenseLayers()
  return children
}

/**
 * Require the region's layers to load before rendering children.
 */
const RequireLayerStore: FC<PropsWithChildren> = ({ children }) => (
  <Suspense fallback={<LoadingOverlay />}>
    <RequireLayers>{children}</RequireLayers>
  </Suspense>
)

export default RequireLayerStore
